<template>
  <div class="publish-task-product">
    <steps :active="4"></steps>
    <el-row :gutter="30" class="main-wrapper">
      <el-col :xs="24" :sm="16" :md="16" :lg="16" :xl="16" class="box gray-box">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <addressDetail :data="taskInfo.address_info" :support_transport_service="taskInfo.support_transport_service"></addressDetail>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <PaymentWay v-if="!isSingle" :order="taskInfo" :data="taskInfo.payment_type_info"></PaymentWay>
            <el-row class="total-line" v-if="isSingle && taskInfo.conditions.buyer_name">
              <el-col :span="24">
                <el-checkbox v-model="checked" @change="change()">
                  <i class="ico ico-offpay"></i>
                  <span class="payname">私下支付</span>
                </el-checkbox>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <div class="product-list box-body">
          <product-list type="confirmPage" :goods-list="taskInfo.goods_list" :page="'confirm'"></product-list>
        </div>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
        <!--<ConditionDetail :data="taskInfo.conditions" :isSingle="isSingle"></ConditionDetail>-->
        <order-total :isSingle="isSingle" :useRate="true" :goods-list="taskInfo.goods_list"></order-total>
        <use-coupon></use-coupon>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import AddProducts from './cart/AddProducts'
import ProductList from './cart/ProductList'
import OrderTotal from './components/OrderTotalConfirm'
import UseCoupon from './components/UseCoupon'
import Steps from './components/Steps'
import AddressDetail from './components/AddressDetail'
import PaymentWay from './payment/PaymentWay'
//import ConditionDetail from './condition/ConditionDetail'
import api from '../../services/api.js'
let _ = require('lodash')

export default {
  name: 'SelectBuyer',
  computed: {
    taskInfo () {
      console.log("taskinfo",this.$store.state.taskInfo)
      return this.$store.state.taskInfo
    }
  },
  components: {
    addProducts: AddProducts,
    productList: ProductList,
    orderTotal: OrderTotal,
    useCoupon: UseCoupon,
    addressDetail: AddressDetail,
    PaymentWay: PaymentWay,
    //ConditionDetail: ConditionDetail,
    steps: Steps,
    isSingle: false
  },
  created () {
    // this.getSingleInfo()
    this.$store.commit('refreshTaskInfo')
    if (this.$route.fullPath.indexOf('buyer') > -1) {
      this.isSingle = true
    } else {
      this.isSingle = false
    }
    if (this.checked) {
      this.taskInfo.offline_payment = '1'
    } else {
      this.taskInfo.offline_payment = '0'
    }
    this.$store.commit('updateTaskInfo', this.taskInfo)
  },
  data () {
    return {
      bussinessList: null,
      checked: false,
      isCompany: false
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!to.query.order_id) {
      next()
      return
    }
    next(async vm => {
      await vm.initEditOrder(to.query.order_id)
    })
  },
  methods: {
    async getSingleInfo () {
      let res = await api.post(this, {
        path: 'single.php',
        api: 'is_company_account',
        loading: 'loading'
      })
      if (res.body.status == 'ok') {
        this.isCompany = res.body.result
      }
    },
    change () {
      if (this.checked) {
        this.taskInfo.offline_payment = '1'
      } else {
        this.taskInfo.offline_payment = '0'
      }
      this.$store.commit('updateTaskInfo', this.taskInfo)
    },
    async initEditOrder (orderId) {
      if (orderId === this.taskInfo.id) {
        _.each(this.taskInfo.goods_list, goods => {
          goods.business_name = this.taskInfo.business.name
          goods.business_id = this.taskInfo.business.id
          goods.business_website = this.taskInfo.business.website
          goods.currency_symbol = this.taskInfo.currency_symbol
          goods.currency = this.taskInfo.currency
        })
        this.taskInfo.business_name = this.taskInfo.business.name
        this.taskInfo.business_id = this.taskInfo.business.id
        this.taskInfo.business_website = this.taskInfo.business.website
        this.$store.commit('updateTaskInfo', this.taskInfo)
        return
      }
      let res = await api.getOrderById(this, {
        order_id: orderId
      })
      res = res.body.result
      res.address_info = res.address
      res.coupon = JSON.parse(res.coupon)
      _.each(res.goods_list, goods => {
        goods.business_name = res.business.name
        goods.business_id = res.business.id
        goods.business_website = res.business.website
        goods.currency_symbol = res.currency_symbol
        goods.currency = res.currency
      })
      res.business.business_website = res.business.website
      res.business.business_name = res.business.name
      res.business.business_id = res.business.id
      this.taskInfo.business_website = res.business.website
      this.taskInfo.business_name = res.business.name
      this.taskInfo.business_id = res.business.id
      Object.assign(this.taskInfo, res)
      this.$store.commit('updateTaskInfo', this.taskInfo)
    },
    async getGroupBussinessList (data) {
      let res = await api.getGroupBussinessList(this, {setLs: true, getLs: true,getLsTime: new Date().getTime()})
      let result = res.body.result
      this.bussinessList = _.groupBy(result, 'id')
      if (this.bussinessList[data.business_id]) {
        data.business_name = this.bussinessList[data.business_id][0].name
        data.business_website = this.bussinessList[data.business_id][0].website
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.main-wrapper{
  margin-top: 30px;
  margin-bottom: 40px;
}

.product-list {
  margin-top: 20px;
  padding: 15px 30px 10px !important;
}

.empty-container {
  text-align: center;
  padding: 50px 0;

  h3 {
    font-size:18px;
    color: #333333;
  }

  p {
    margin: 13px 0 18px;
    font-size:13px;
    color: #666666;
    line-height: 18px;
  }
}
.total-line {
  color: #686B73;
  line-height: 22px;
  border: 1px solid #DEE2EC;
  padding: 20px 30px;

  .name {
    font-size: 16px;
    margin-bottom: 5px;
  }
  .payname {
    font-size: 16px;
    margin-left: 5px;
  }
  .ico-offpay {
    background-image: url('../../ico/ic_payment_cash.png');
    background-size: cover;
    width: 24px;
    height: 24px;
  }
}

@media screen and (max-width:769px){
  .main-wrapper {
    padding: 0 10px;

  }
  .product-list {
    padding: 15px 13px 0px !important;
    margin-top: 10px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/Confirm.vue